import { render, staticRenderFns } from "./RealButton.vue?vue&type=template&id=122a328c&scoped=true&"
import script from "./RealButton.vue?vue&type=script&lang=js&"
export * from "./RealButton.vue?vue&type=script&lang=js&"
import style0 from "./RealButton.vue?vue&type=style&index=0&id=122a328c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122a328c",
  null
  
)

export default component.exports